
Ext.define('SA.view.quickreport.QuickReportLayout', {
    alias: 'quickreport.layout',

    constructor(view) {
        this.view = view;
    },

    destroy() {
        this.view = null;
    },

    get(selector) {
        var cache = this.elCache,
            el = cache[selector] = (cache[selector] || this.getViewEl().down(selector, true));

        return el;
    },

    getBody() {
        return this.get('.sa-quick-report-body');
    },

    getBodyWrap() {
        return this.get('.sa-quick-report-body-wrap');
    },

    getFirstCol() {
        return this.get('.sa-quick-report-first-col');
    },

    getFirstColEffectiveWidth() {
        return this.get('.sa-quick-report-first-col-sections').getBoundingClientRect().width;
    },

    getGrid() {
        return this.get('.sa-quick-report-grid');
    },

    getHeader() {
        return this.get('.sa-quick-report-header');
    },

    getHeaderHeight() {
        return this.getHeader().getBoundingClientRect().height;
    },

    getScrollbarHeight() {
        return Ext.getScrollbarSize().height;
    },

    getScrollbarWidth() {
        return Ext.getScrollbarSize().width;
    },

    getViewEl() {
        return this.view.el;
    },

    getViewHeight() {
        return this.view.getSize().height;
    },

    getViewWidth() {
        return this.view.getSize().width;
    },

    refresh() {
        this.elCache = {};

        Ext.getScrollbarSize(true);

        this.refreshColumnWidths();
        this.refreshHeaderElHeights();
        this.refreshBodyRowHeights();
        this.refreshPositions();
        this.refreshFirstCellMaskSize();
        this.refreshFirstColAndBodyWrapSizeAndOverflow();
        this.refreshGridSize();
        this.refreshLoadMaskSize();
        this.refreshScrollbarCapLayout();

        this.elCache = null;
    },

    refreshFirstColAndBodyWrapSizeAndOverflow() {
        var viewEl = this.getViewEl(),
            body = this.getBody(),
            bodyWrap = this.getBodyWrap(),
            firstCol = this.getFirstCol(),
            bodyWidth = body.scrollWidth,
            bodyHeight = body.scrollHeight,
            maxBodyWidth = Math.max(this.getViewWidth() - this.getFirstColEffectiveWidth() - 2, 0),
            maxBodyHeight = Math.max(this.getViewHeight() - this.getHeaderHeight() - 2, 0),
            bodyPlusScrollbarWidth = bodyWidth + this.getScrollbarWidth(),
            bodyPlusScrollbarHeight = bodyHeight + this.getScrollbarHeight(),
            bodyPlusScrollbarHeightOverflows = bodyPlusScrollbarHeight > maxBodyHeight,
            needsScrollX = false,
            needsScrollY = false,
            bodyWrapWidth, bodyWrapHeight;

        if (bodyWidth > maxBodyWidth) {
            needsScrollX = true;
        }

        if (bodyHeight > maxBodyHeight || (needsScrollX && bodyPlusScrollbarHeightOverflows)) {
            needsScrollY = true;

            if (bodyPlusScrollbarWidth > maxBodyWidth) {
                needsScrollX = true;

                if (bodyPlusScrollbarHeightOverflows) {
                    needsScrollY = true;
                }
            }
        }

        bodyWrapWidth = Math.min((needsScrollY ? bodyPlusScrollbarWidth : bodyWidth), maxBodyWidth);
        bodyWrapHeight = Math.min((needsScrollX ? bodyPlusScrollbarHeight : bodyHeight), maxBodyHeight);

        Ext.fly(firstCol).setHeight(bodyWrapHeight);
        Ext.fly(bodyWrap).setSize(bodyWrapWidth, bodyWrapHeight);

        viewEl.ifCls(needsScrollX, 'sa-quick-report-has-scroll-x');
        viewEl.ifCls(needsScrollY, 'sa-quick-report-has-scroll-y');
    },

    refreshColumnWidths() {
        var viewEl = this.getViewEl(),
            headerCells = viewEl.select('.sa-quick-report-header-cell'),
            getMaxWidth = els => Math.max(...els.slice().map(el => el.getBoundingClientRect().width));

        headerCells.each(headerCell => {
            var location = headerCell.dom.getAttribute('data-location-series'),
                bodyColumnEl = viewEl.select(`.sa-quick-report-body-column[data-location-series="${location}"]`).first(),
                select = selector => bodyColumnEl.select(selector),
                leftCells = select('.sa-quick-report-body-cell-left'),
                rightCells = select('.sa-quick-report-body-cell-right'),
                bodyHeaderCells = select('.sa-quick-report-body-header-cell'),
                bodyFooterCells = select('.sa-quick-report-body-footer-cell'),
                leftSideWidth = getMaxWidth(leftCells),
                rightSideWidth = getMaxWidth(rightCells),
                colWidth = leftSideWidth + rightSideWidth;

            headerCell.setWidth(colWidth);
            bodyHeaderCells.setWidth(colWidth);
            leftCells.setWidth(leftSideWidth);
            rightCells.setWidth(rightSideWidth);
            bodyFooterCells.setWidth(colWidth);
        });
    },

    refreshFirstCellMaskSize() {
        var mask = this.get('.sa-quick-report-first-cell-mask'),
            width = this.getFirstColEffectiveWidth() + 1,
            height = this.getHeaderHeight() + 1;

        Ext.fly(mask).setSize(width, height);
    },

    refreshGridSize() {
        var grid = this.getGrid(),
            bodyWrapSize = this.getBodyWrap().getBoundingClientRect(),
            width = 2 + this.getFirstColEffectiveWidth() + bodyWrapSize.width,
            height = 2 + this.getHeaderHeight() + bodyWrapSize.height;

        Ext.fly(grid).setSize(width, height);
    },

    refreshHeaderElHeights() {
        var viewEl = this.getViewEl(),
            identifierEls = viewEl.select('.sa-quick-report-header-location-identifier'),
            typeEls = viewEl.select('.sa-quick-report-header-location-type');

        identifierEls.setHeight(null);
        identifierEls.setHeight(getMaxHeight(identifierEls));

        typeEls.setHeight(null);
        typeEls.setHeight(getMaxHeight(typeEls));

        function getMaxHeight(els) {
            return Ext.Array.max(els.slice().map(el => {
                return Ext.fly(el).getHeight();
            }));
        }
    },

    refreshLoadMaskSize() {
        var gridSize = Ext.fly(this.getGrid()).getSize(),
            width = Math.min(this.getViewWidth(), gridSize.width),
            height = Math.min(this.getViewHeight(), gridSize.height);

        this.view.setLoadMaskSize(width, height);
    },

    refreshPositions() {
        var header = this.getHeader(),
            firstCol = this.getFirstCol(),
            bodyWrap = this.getBodyWrap(),
            left = this.getFirstColEffectiveWidth() + 'px',
            top = this.getHeaderHeight() + 'px';

        Ext.fly(header).setStyle('left', left);
        Ext.fly(firstCol).setStyle('top', top);
        Ext.fly(bodyWrap).setStyle({left, top});
    },

    refreshBodyRowHeights() {
        var viewEl = this.getViewEl(),
            bodyColumns = viewEl.query('.sa-quick-report-body-column'),
            firstColRowHeights = getFirstColRowHeights();

        bodyColumns.forEach(column => {
            var columnRows = Ext.fly(column).query('.sa-quick-report-body-row');

            columnRows.forEach((row, i) => {
                Ext.fly(row).setHeight(firstColRowHeights[i]);
            });
        });

        function getFirstColRowHeights() {
            var rows = viewEl.query('.sa-quick-report-first-col-row');

            return rows.map(row => row.getBoundingClientRect().height);
        }
    },

    refreshScrollbarCapLayout() {
        var headerCap = this.get('.sa-quick-report-header-scrollbar-cap'),
            firstColCap = this.get('.sa-quick-report-first-col-scrollbar-cap'),
            headerHeight = this.getHeaderHeight(),
            barWidth = this.getScrollbarWidth(),
            barHeight = this.getScrollbarHeight();

        Ext.fly(headerCap).setSize(barWidth, headerHeight);
        Ext.fly(firstColCap).setHeight(barHeight);
    }
});